<template>
  <div>
    <b-form-group label-cols="3" horizontal label="예약 내용" class="mt-4">

      <b-form-group label-cols="4" label="예약번호">
        <b-form-input :plaintext="true" v-model="data.bookingNo"/>
      </b-form-group>

      <b-form-group label-cols="4" label="예약자">
        <b-form-input :plaintext="!editFlag" v-model="data.visitorName"/>
      </b-form-group>

      <b-form-group label-cols="4" label="전화번호">
        <b-form-input :plaintext="!editFlag" v-model="data.visitorPhone"/>
      </b-form-group>

      <b-form-group label-cols="4" label="인원">
        <b-row>
          <p style="padding-left: 15px; margin: 0; width: 100%;">성인 : {{ data.adultHeadcount }}명 </p>
          <!--          <b-form-input style="width:75%; padding: 0;" :plaintext="!editFlag" v-model="data.adultHeadcount" type="number" max="100" min="0"/>-->
          <p style="padding-left: 15px; margin: 0; width: 100%;">소인 : {{ data.childHeadcount }}명</p>
          <!--          <b-form-input style="width:85%; padding: 0;" :plaintext="!editFlag" v-model="data.childHeadcount" type="number" max="100" min="1"/>-->
          <p style="padding-left: 15px; margin: 0; width: 100%;">유아 : {{ data.babyHeadcount }}명</p>
          <!--          <b-form-input style="width:85%; padding: 0;" :plaintext="!editFlag" v-model="data.babyHeadcount" type="number" max="100" min="1"/>-->

        </b-row>

      </b-form-group>
      <b-form-group label-cols="4" label="요청사항">
        <b-form-input :plaintext="!editFlag" v-model="data.visitorRequests"/>
      </b-form-group>

      <b-form-group label-cols="4" label="방문매장">
        <b-form-input :plaintext="true" v-model="data.storeName"/>
      </b-form-group>

      <b-form-group label-cols="4" label="방문예정일">
        <b-form-input :plaintext="true" v-model="reservationDate"/>
      </b-form-group>

      <b-form-group label-cols="4" label="예약신청일">
        <b-form-input :plaintext="true" v-model="bookingRequestDate"/>
      </b-form-group>

      <b-form-group label-cols="4" label="예약상태">
        <b-form-input :plaintext="true" v-model="bookingStatusText"/>
      </b-form-group>
    </b-form-group>

    <div>
      <b-button v-b-toggle.collapse-1 variant="primary">쿠폰구매내역 {{ data.adultHeadcount+data.childHeadcount+data.babyHeadcount }}</b-button>
      <b-collapse id="collapse-1" label-cols="2" horizontal label="쿠폰구매내역" class="mt-4">
      <b-table
        stacked
        class="vuetable bklMtable bdmM"
        id="table-transition-example"
        :items="data.orderItems"
        :fields="fields">
        <template v-slot:cell(itemNo)="row">
          <div>쿠폰번호</div>
          <div>{{row.item.itemNo}}</div>
        </template>
        <template v-slot:cell(goodsName)="row">
          <div>상품명</div>
          {{row.item.goodsName}}
        </template>
        <template v-slot:cell(optionName)="row">
          <div>옵션명</div>
          {{row.item.optionName}}
        </template>
        <template v-slot:head(unused)="row" v-if="checkUse">
          <b-form-checkbox :checked="true" :unchecked-value="false" v-model="allCheck"></b-form-checkbox>
        </template>
        <template v-slot:cell(unused)="row" v-if="checkUse">
          <b-form-checkbox :checked='true' :unchecked-value='false' v-model="row.item.unused"></b-form-checkbox>
        </template>
      </b-table>
    </b-collapse>
    </div>
    


  </div>
</template>
<script>

import {alignTableCenter} from "../../../../utils";
import {_bookingStatus} from "../../../../constants/common";

export default {
  name: 'BookingVisitDetail',
  components: {},
  props: ['data', 'modifyFlag', 'checkUseFlag'],
  data() {
    return {
      editFlag: this.modifyFlag !== undefined ? this.modifyFlag : false,
      checkUse: this.checkUseFlag !== undefined ? this.checkUseFlag : true,
      allCheck: false,
      orderItemsFields: [
        {key: 'itemNo', label: "", ...alignTableCenter},
        {key: 'goodsName', label: "", ...alignTableCenter},
        {key: 'optionName', label: "",...alignTableCenter},
      ],
    }
  },

  computed: {

    fields: {
      get: function() {
        return this.checkUse === false ? this.orderItemsFields : [...this.orderItemsFields, {
          key: 'unused',
          label: '', ...alignTableCenter
        }]
      }
    },
    bookingStatusText: {
      get: function() {
        return _bookingStatus[this.data.bookingStatus]
      }
    },
    reservationDate: {
      get: function() {
        return this.$moment(this.data.reservationDate).format('YYYY-MM-DD HH:mm')
      }
    },
    bookingRequestDate: {
      get: function() {
        return this.$moment(this.data.bookingRequestDate).format('YYYY-MM-DD HH:mm')
      }
    },
    headcount: {
      get: function() {
        return {adult: 0, child: 0}
      }
    }
  },

  mounted() {
    this.allCheck = true
  },
  methods: {}
  ,
  watch: {

    allCheck(chk) {
      this.data.orderItems.forEach(function(value) {
        value.unused = chk
      })
    }
  }
}
</script>
